import DarkMode from "@mui/icons-material/DarkMode";
import WbSunny from "@mui/icons-material/WbSunny";
import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SHIFT_DAY, SHIFT_NIGHT_FALLBACK } from "../../../theme/tokens";
import { ShiftType } from "../../../utils/models";
import { type SystemChipItem, SystemChips } from "../Clickable/TabsAndChips/SystemChips/SystemChips";
export type ShiftTypeFilterValue = ShiftType.All | ShiftType.Day | ShiftType.Night;

type Props = {
	value: ShiftTypeFilterValue;
	onChange: (next: ShiftTypeFilterValue) => void;
	dataTestId?: string;
};

const transparentAvatarSx = { "& .MuiChip-avatar": { backgroundColor: "transparent", marginLeft: "6px" } };

export const ShiftTypeFilterChips: FC<Props> = ({ value, onChange, dataTestId }) => {
	const { t } = useTranslation();
	const items = useMemo<SystemChipItem<ShiftTypeFilterValue>[]>(
		() => [
			{ value: ShiftType.All, label: t("All") },
			{ value: ShiftType.Day, label: t("Day"), startAdornment: <WbSunny sx={{ fontSize: 16, color: SHIFT_DAY }} /> },
			{ value: ShiftType.Night, label: t("Night"), startAdornment: <DarkMode sx={{ fontSize: 16, color: SHIFT_NIGHT_FALLBACK }} /> },
		],
		[t],
	);
	const selectedItems = useMemo(() => items.filter((item) => item.value === value), [items, value]);

	return (
		<SystemChips
			variant="filled"
			rootSx={{ width: "100%", justifyContent: "flex-start" }}
			items={items}
			selectedItems={selectedItems}
			onChange={(item, selected) => onChange(selected ? item.value : ShiftType.All)}
			selectedSx={transparentAvatarSx}
			unselectedSx={transparentAvatarSx}
			dataTestId={dataTestId}
		/>
	);
};
